import { isCurrentCultureRightToLeft } from 'owa-localize';
import { snapToGrid } from 'owa-timestream-store';
import { ASSUMED_ASSET_WIDTH, ASSET_PADDING } from 'owa-timestream-asset-sdk';

/**
 * Finds the coordinates for an asset created via click (versus click and drag).
 * If in RTL, creates the asset right of the activity pane rather than left, since activity pane
 * is flipped.
 * @param bounds bounds for the canvas layter
 * @param pan pan values for the document surface
 * @param zoom zoom values for the document surface
 * @param targetRect target element being added to the canvas
 */
export default function getCoordinatesForNewAsset(
    bounds: { top: number; left: number; right: number; width: number; height: number },
    pan: { x: number; y: number },
    zoom: number,
    targetRect: DOMRect
): { x: number; y: number } {
    const x = isCurrentCultureRightToLeft()
        ? targetRect.right - bounds.left - pan.x + ASSET_PADDING
        : targetRect.left -
          (targetRect.left - bounds.right) -
          pan.x -
          (ASSUMED_ASSET_WIDTH + ASSET_PADDING);

    return {
        x: snapToGrid(x / zoom),
        y: snapToGrid((targetRect.top - bounds.top - pan.y) / zoom),
    };
}
